import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import CancelIcon from '@/assets/cancel.svg?react';

const FilterChip = ({
  label,
  onRemove,
  'aria-label': ariaLabel,
}: {
  label: ReactNode;
  onRemove: () => void;
  'aria-label'?: string;
}) => {
  return (
    <Root
      onClick={onRemove}
      aria-label={ariaLabel}
      role="button"
    >
      <Label>{label}</Label>
      <CancelIcon />
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.radii.xxs,
  background: theme.palette.grey200,
  color: theme.palette.grey500,
  fontSize: '10px',
  lineHeight: '12px',
  fontWeight: 600,
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  cursor: 'pointer',
  transition: 'background 0.2s ease-in-out',

  path: {
    stroke: theme.palette.grey500,
  },

  '&:hover': {
    background: theme.palette.grey300,
  },
}));

const Label = styled('div')(({ theme }) => ({
  padding: `0 ${theme.spacing(1)}`,
}));

export default FilterChip;
